var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.startShow)?_c('div',{staticClass:"start-video"},[_c('video',{ref:"video",attrs:{"src":_vm.video,"autoplay":"","muted":""},domProps:{"muted":true}}),_c('div',{staticClass:"esc"},[_vm._v("Esc退出")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }